// 2026-11-05 (feedback pipeline): Home's "Fixed since your last visit": the user's unseen notices that a report of
// theirs shipped ("Fixed") or was declined ("Not planned: <reason>"). Dismiss marks them seen. Nothing shows when
// there's nothing new (or the call fails: it's a nice-to-have, never an error on Home).
import { useState } from "react";
import { fixedNotices, markNoticesSeen, noticeOutcome, quoteShort, unseenNotices } from "../pipeline";
import { Icon, useLoad } from "./bits";

export function FixedCard() {
  const { data } = useLoad(() => unseenNotices().then(fixedNotices), []);
  const [gone, setGone] = useState(false);
  if (gone || !data?.length) return null;
  const dismiss = () => {
    setGone(true);
    void markNoticesSeen(data.map((n) => n.id)).catch(() => undefined);
  };
  return (
    <section className="fixed-card" aria-labelledby="fixed-h">
      <div className="draft-head">
        <Icon name="check" size={16} />
        <h2 id="fixed-h">
          {data.some((n) => n.kind === "shipped") ? "Fixed since your last visit" : "About your reports"}
        </h2>
        <button type="button" className="icon-btn draft-x" onClick={dismiss} aria-label="Dismiss">
          <Icon name="close" size={16} />
        </button>
      </div>
      <ul>
        {data.slice(0, 5).map((n) => (
          <li key={n.id}>
            {n.report ? <>“{quoteShort(n.report)}” </> : null}
            <span className={`fixed-outcome${n.kind === "declined" ? " is-declined" : ""}`}>{noticeOutcome(n)}</span>
          </li>
        ))}
      </ul>
      <button type="button" className="btn btn-quiet btn-small" onClick={dismiss}>
        Got it
      </button>
    </section>
  );
}
